import config from '../config';

/**
 * Split configuration settings to be used on the browser
 */
export const splitConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: config.get('splitio.authorizationKey'),
    key: 'NO_SEGMENT_ID',
  },
  scheduler: {
    impressionsRefreshRate: config.get('splitio.impressionsRefreshRate'),
  },
  debug: config.get('splitio.debug'),
};
